import makeStyles from "@mui/styles/makeStyles";
import { Dropdown, DropdownChangeParams } from "primereact/dropdown";
import { useTranslation } from "react-i18next";
import { AccessLocation } from "../../shared/enums/Result";
import { ValidationMessage } from "../../shared/ValidationMessage";

interface Props {
  selectedAccessLocation: AccessLocation | undefined;
  invalid?: boolean;
  invalidMessage?: string;
  onChange: (accessLocation?: AccessLocation) => void;
  disabled: boolean;
}

const useStyles = makeStyles((theme) => ({
  dropdownContainer: {
    position: "relative",
    width: "100%",
  },
  dropdownRoot: {
    width: "100%",
  },
  validationMessage: {
    position: "absolute",
    top: "100%",
    left: 0,
    marginTop: "5px",
    zIndex: 1,
  },
}));

export function AccessLocationDropdown(props: Props) {
  const { t } = useTranslation();
  const classes = useStyles();

  const { selectedAccessLocation, onChange } = props;

  const dropdownOptions = Object.values(AccessLocation).map((accessLocation) => ({
    label: t(`AccessLocations.${accessLocation}`),
    value: accessLocation,
  }));

  function handleChange(e: DropdownChangeParams) {
    onChange(e.value);
  }

  return (
    <div className={classes.dropdownContainer}>
      <Dropdown
        disabled={props.disabled}
        value={selectedAccessLocation}
        options={dropdownOptions}
        onChange={handleChange}
        placeholder={t("AccessLocations.selectAccessLocation")}
        className={classes.dropdownRoot}
      />

      {props.invalid && props.invalidMessage && (
        <div className={classes.validationMessage}>
          <ValidationMessage invalidMessage={props.invalidMessage} validationType="error" showIcon />
        </div>
      )}
    </div>
  );
}
